<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Lezen basis | Huiswerkmodus" [steps]="words().length" [progress]="index()" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="instruction()" />

    @for (input of [word()]; track input) {
      <div class="relative flex flex-col place-items-center gap-4">
        <div class="relative">
          @if (showCountdown()) {
            <rid-reading-countdown #countdown />
          }
          <rid-segmented-word-card
            #card
            [segments]="input.word"
            mode="READING"
            [hideText]="showCountdown()"
            animate.enter="anim-pop-in"
            ridSfx="BUBBLE_POP"
            (mouseenter)="state() === 'ASSESSING' ? card.show() : undefined"
            (mouseleave)="state() === 'ASSESSING' ? card.hide() : undefined"
          />
        </div>
      </div>
    }

    @if (state() === 'ASSESSING') {
      <rid-assessment-toast (assessed)="assessed($event === 'CORRECT')" />
    }

    @if (state() === 'DONE') {
      <rid-bottom-button content="Volgende" (clicked)="next()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
